import type { OverlayData } from "../../../types/navigation.ts";

type RectProps = OverlayData & {
  onClick: () => void;
};

export function OverlayRect({
  x,
  y,
  width,
  height,
  label,
  onClick,
}: RectProps) {
  return (
    <button
      className="overlay overlay-rect"
      aria-label={label}
      style={{
        left: `${x}%`,
        top: `${y}%`,
        width: `${width}%`,
        height: `${height}%`,
      }}
      onClick={onClick}
    />
  );
}
